"use client";
import React from 'react';
import { motion } from 'framer-motion';

const lines = [
    { text: "Most UI/UX agencies focus on screens.", accent: false },
    { text: "We focus on behaviour.", accent: true },
    { text: "Good design isn't about making users think more.", accent: false },
    { text: "It's about helping them think less.", accent: true },
    { text: "Every interaction should feel natural.", accent: false },
    { text: "Every journey should feel effortless.", accent: false },
    { text: "Every experience should move users closer to their goal.", accent: false },
];

export default function UXExpectations() {
    return (
        <section className="relative overflow-hidden py-24 px-6 md:px-16 lg:px-24" style={{ background: '#ffffff' }}>
            <div className="absolute inset-0 pointer-events-none" style={{
                backgroundImage: 'radial-gradient(circle, rgba(55,48,163,0.06) 1.5px, transparent 1.5px)',
                backgroundSize: '32px 32px',
                maskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)',
                WebkitMaskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)',
            }} />

            <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row gap-16 items-start relative z-10">

                {/* Left */}
                <div className="flex-1 flex flex-col gap-5 max-w-xl">
                    <motion.span
                        initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
                        className="text-xs font-bold tracking-[0.2em] uppercase"
                        style={{ color: '#3730a3', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}>
                        Why Lead Workz
                    </motion.span>
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
                        className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-wide leading-tight"
                        style={{ fontFamily: 'var(--font-clash), "Clash Display", sans-serif', color: '#3730a3' }}>
                        Why Businesses Choose Lead Workz
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }}
                        className="text-base md:text-lg leading-relaxed"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(8,4,0,0.55)', letterSpacing: '0.02em' }}>
                        By combining psychology, research, design, and business strategy, we create user experiences that drive engagement, trust, and long-term product adoption.
                    </motion.p>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.3 }}
                        className="text-base md:text-lg font-semibold"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: '#3730a3', letterSpacing: '0.02em' }}>
                        Because the best user experiences are the ones users barely notice. They simply work.
                    </motion.p>
                </div>

                {/* Right — statement lines */}
                <div className="flex-1 flex flex-col gap-4">
                    {lines.map((line, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            className="flex items-start gap-3"
                        >
                            <div className="shrink-0 mt-2" style={{ width: 6, height: 6, borderRadius: '50%', background: line.accent ? '#3730a3' : 'rgba(55,48,163,0.25)' }} />
                            <p
                                className="text-lg md:text-xl font-semibold leading-snug"
                                style={{
                                    fontFamily: 'var(--font-manrope), Manrope, sans-serif',
                                    color: line.accent ? '#3730a3' : 'rgba(8,4,0,0.45)',
                                    letterSpacing: '0.01em',
                                }}>
                                {line.text}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
